<template>
    <div id="header" class="title-common">
        <ButtonGoBack v-if="isShowButtonBack" :isEmitGoBack="isEmitGoBack" @on-click-go-back="onClickGoBack()" />
        <span class="title-common__text">{{ getTranslatedText(title) }}</span>
    </div>
</template>
<script>
import languageMixins from '@/mixins/language-mixins';
import ButtonGoBack from '@/components/common/buttonBack/buttonBack.vue';

export default {
    mixins: [languageMixins],
    components: { ButtonGoBack },
    props: {
        title: {
            type: String,
            default: '',
        },
        isShowButtonBack: {
            type: Boolean,
            default: false,
        },
        isEmitGoBack: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        onClickGoBack() {
            this.$emit('on-click-go-back');
        },
    },
};
</script>

<style lang="scss">
@import '@/public/scss/common/title.scss';
</style>
